import React, {useEffect,useContext , useState} from 'react';
import { Context } from '../index';
import { useNavigate } from "react-router-dom";
import Spin from '../components/UI/Spin/Spin';
import { useLocation } from 'react-router-dom';
const GoogleAuth = () => {
    const { store } = useContext(Context);
    const navigate = useNavigate()
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const room_id = queryParams.get('room');
    useEffect(()=>{
        regGoogle()
    } , [])
    async function regGoogle(){
        const aswer_from_response = await store.checkAuth(); // Ожидание завершения функции

        if (room_id){
            window.location.replace("https://snake.money/game/"+room_id)
        }
        else{
            navigate("/")
        }
        
    }
    return (
        <div>
            <Spin/>
        </div>
    );
};

export default GoogleAuth;